import { Component, OnInit, ViewChild } from '@angular/core';
import { AgenteDto } from '../../../dto/justino/agente.dto';
import { AgenteService } from '../../../services/agente.service';
import { ModalNomDesComponent } from '../modal-nom-des/modal-nom-des.component';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { SpinnerService } from '../../../services/util/spinner.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RolService } from '../../../services/rol.service';
import { RolDto } from '../../../dto/justino/rol.dto';
import { BaseConocimientoService } from '../../../services/base-conocimiento.service';
import { BaseConocimientoDto } from '../../../dto/justino/base-conocimiento.dto';

@Component({
  selector: 'app-agentes',
  templateUrl: './agentes.component.html',
  styleUrl: './agentes.component.scss',
})
export class AgentesComponent implements OnInit {
  // Track the current page
  currentPage: number = 1;
  // Track the search term
  searchTerm: string = '';
  // Define la lista de agentes
  agentes: AgenteDto[] = [];
  // Define la lista de roles
  roles: RolDto[] = [];
  // Define el mensaje sin datos
  mensaje: string = 'No hay datos disponibles.';
  modalNDFlag: boolean = false;
  listFlag: boolean = true;
  readFlag: boolean = false;
  agente!: AgenteDto;

  agenteForm!: FormGroup;
  isReadOnly: boolean = true;
  nomDesForm: any[] = [
    {
      name: 'nombre',
      label: 'Nombre',
      type: 'text',
      required: true,
      width: '12',
      visible: true,
      errorMessages: {
        required: 'El nombre es requerido',
        pattern:
          'Solo se permiten letras, números y guiones (-). Ejemplo: nombre-1, dos-nombres',
      },
    },
    {
      name: 'descripcion',
      label: 'Descripción',
      type: 'textarea',
      required: true,
      width: '12',
      visible: true,
    },
    {
      name: 'estado',
      label: 'Estado',
      type: 'select1',
      required: true,
      width: '6',
      visible: true,
      errorMessages: { required: 'El estado es obligatorio' },
    },
    {
      name: 'rol',
      label: 'Rol',
      type: 'select2',
      required: true,
      width: '6',
      visible: true,
      errorMessages: { required: 'El rol es obligatorio' },
    },
    {
      name: 'cardinalidad',
      label: 'Cardinalidad',
      type: 'number',
      required: true,
      width: '6',
      visible: true,
      errorMessages: {
        required: 'La cardinalidad es requerida',
      },
    },
  ];
  estados = ['Activo', 'Inactivo'];

  @ViewChild(ModalNomDesComponent)
  modalND!: ModalNomDesComponent;

  constructor(
    private fb: FormBuilder,
    private rolService: RolService,
    private spinnerService: SpinnerService,
    private agenteService: AgenteService,
    private alertService: AlertaModalService
  ) {}

  ngOnInit(): void {
    this.loadRoles();
    this.loadAgentes();
    this.createForm();
  }

  loadRoles(): void {
    this.rolService.getRoles().subscribe({
      next: data => {
        // Filtrar solo los roles activos
        this.roles = data.filter(rol => rol.Estado === 'Activo');
      },
      error: err => {
        this.alertService.error(`Error al cargar los roles: ${err.statusText}`);
      },
    });
  }

  loadAgentes(): void {
    this.agenteService.getAgentes().subscribe({
      next: data => {
        this.agentes = data;
      },
      error: err => {
        this.alertService.error(
          `Error al cargar los agentes: ${err.statusText}`
        );
      },
    });
  }

  editarAgente(agente: AgenteDto) {
    this.agente = agente;
    this.listFlag = false;
    this.readFlag = true;
    this.isReadOnly = false;
    this.fillFormWithData();
    if (this.isReadOnly) {
      this.agenteForm.disable();
    } else {
      this.agenteForm.enable();
    }
  }

  eliminarAgente(id: string) {
    this.alertService.confirmacion(
      '¿Desea eliminar el agente?',
      'Eliminar',
      () => {
        this.agenteService.deleteAgente(id).subscribe({
          next: () => {
            this.spinnerService.hideSpinner();
            this.alertService.exito(
              'Mensaje informativo',
              'Agente eliminado correctamente'
            );
            this.loadAgentes();
          },
          error: err => {
            this.spinnerService.hideSpinner();
            this.alertService.error(
              `Error al eliminar el agente: ${err.statusText}`
            );
          },
        });
      },
      () => {}
    );
  }

  registrarAgente(dto: any) {
    const nuevoNombre = dto.nombre;
    const nuevoDescripcion = dto.descripcion;
    this.modalND.abrirCerrarModal();
    if (nuevoNombre && nuevoNombre.trim() !== '') {
      const nuevoAgente: AgenteDto = {
        Id: '0',
        Nombre: nuevoNombre,
        Descripcion: nuevoDescripcion,
        Estado: 'Activo',
        FechaCreacion: new Date().toISOString(),
        FechaModificacion: new Date().toISOString(),
        UsuarioCreacion: 'admin',
        UsuarioModificacion: 'admin',
        Rol: undefined,
        Cardinalidad: 1,
      };
      this.agenteService.createAgente(nuevoAgente).subscribe({
        next: () => {
          this.spinnerService.hideSpinner();
          this.alertService.exito(
            'Mensaje informativo',
            'Agente creado correctamente'
          );
          this.loadAgentes();
        },
        error: err => {
          this.spinnerService.hideSpinner();
          this.alertService.error(`Error al crear el agente ${err.statusText}`);
        },
      });
    }
  }

  async crearAgente() {
    this.abrirModalND();
  }

  abrirModalND() {
    this.modalNDFlag = true;
    setTimeout(() => {
      this.modalND.abrirCerrarModal();
    }, 500);
  }

  onRowClick(agente: AgenteDto) {
    this.agente = agente;
    this.listFlag = false;
    this.readFlag = true;
    this.isReadOnly = this.readFlag;
    this.fillFormWithData();
    if (this.isReadOnly) {
      this.agenteForm.disable();
    } else {
      this.agenteForm.enable();
    }
  }

  volverElemento() {
    this.listFlag = true;
    this.readFlag = false;
    this.isReadOnly = this.readFlag;
    this.agenteForm.reset();
  }

  createForm(): void {
    const formControls: any = {};
    this.nomDesForm.forEach(field => {
      const validators = [];
      if (field.required) {
        validators.push(Validators.required);
      }
      if (field.name === 'nombre') {
        validators.push(Validators.pattern(/^[a-zA-Z0-9-]+$/));
      }
      formControls[field.name] = [null, validators];
    });
    this.agenteForm = this.fb.group(formControls);
    if (this.isReadOnly) {
      this.agenteForm.disable();
    }
  }

  fillFormWithData(): void {
    if (this.agente) {
      const rol = this.roles.find(r => r.Id === this.agente.Rol);
      this.agenteForm.patchValue({
        nombre: this.agente.Nombre,
        descripcion: this.agente.Descripcion,
        estado: this.agente.Estado,
        rol: rol ? rol.Id : null,
        cardinalidad: this.agente.Cardinalidad,
      });
    }
  }

  getErrorMessage(field: string): string | null {
    const control = this.agenteForm.get(field);
    if (control?.invalid && control.touched) {
      const errorType = Object.keys(control.errors!)[0];
      return (
        this.nomDesForm.find(f => f.name === field)?.errorMessages?.[
          errorType
        ] || 'Campo inválido'
      );
    }
    return null;
  }

  toggleEdit(): void {
    this.isReadOnly = !this.isReadOnly;
    if (this.isReadOnly) {
      this.agenteForm.disable();
    } else {
      this.agenteForm.enable();
    }
  }

  isNameUnique(name: string): boolean {
    return !this.agentes.some(
      el => el.Nombre.toLowerCase() === name.toLowerCase()
    );
  }

  submitForm(): void {
    if (this.agenteForm.valid) {
      const dto = this.agenteForm.value;
      if (this.agente.Nombre != dto.nombre) {
        if (!this.isNameUnique(dto.nombre)) {
          this.alertService.error(
            'Error al actualizar el agente',
            'El nombre ya existe'
          );
          return;
        }
      }
      this.agente.Nombre = dto.nombre;
      this.agente.Descripcion = dto.descripcion;
      this.agente.Estado = dto.estado;
      this.agente.Rol = dto.rol;
      this.agente.Cardinalidad = dto.cardinalidad;
      this.agenteService.updateAgente(this.agente.Id, this.agente).subscribe({
        next: () => {
          this.spinnerService.hideSpinner();
          this.alertService.exito(
            'Mensaje informativo',
            'Agente actualizado correctamente'
          );
          this.loadAgentes();
        },
        error: err => {
          this.spinnerService.hideSpinner();
          this.alertService.error(
            `Error al actaulizar el agente: ${err.statusText}`
          );
        },
      });
      this.isReadOnly = true;
      this.agenteForm.disable();
    } else {
      this.agenteForm.markAllAsTouched();
    }
  }
}
